package br.com.texeratx.boardgametimeapp.domain.usecases.expansions

import br.com.texeratx.boardgametimeapp.data.repository.ExpansionRepository
import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO

class GetAllExpansionsUseCase(
    private val repo: ExpansionRepository
) {
    suspend operator fun invoke(): Result<List<ExpansionDTO>> {
        return repo.getAllExpansions()
    }
}
